import { useQuery } from '@tanstack/react-query'
import { baseClient } from 'builder/modules/apiClient'

import { MappedProgressData, ProgressData } from '../types'
import { useServiceData } from './useServiceData'
import { mapProgressData } from './mapProgressDataUtil'

export const useGetProgress = () => {
  const serviceData = useServiceData()

  return useQuery({
    queryKey: ['progressTrackerDashboard'],
    queryFn: async (): Promise<MappedProgressData> => {
      const { data } = await baseClient.get<ProgressData>('/stepper/dashboard')
      return mapProgressData(data, serviceData)
    },
    placeholderData: mapProgressData(undefined, serviceData),
    useErrorBoundary: false,
    cacheTime: 0,
  })
}
